export default "__VITE_ASSET__DBJ7NC5R__";